import { useQuery } from "@tanstack/react-query";

import { payrollApi } from "@/lib/api";

/**
 * Ringkasan payroll bulanan. Kunci query menyertakan bulan supaya pindah
 * bulan otomatis refetch.
 */
export function usePayrollSummary(month: string) {
    return useQuery({
        queryKey: ["payroll-summary", month],
        queryFn: ({ signal }) => payrollApi.summary(month, signal),
    });
}
